import { ISettingBooleanItem } from "../../interfaces/setting-items/ISettingBooleanItem";
import { ISettingResponseItem } from "../../interfaces/setting-items/ISettingResponseItem";

export const fromStringBool = (setting: ISettingResponseItem): ISettingBooleanItem => {
    return {
        type: "Boolean",
        value: setting.value.toLowerCase() === "true"
    };
};
